var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-0"},[_c('v-col',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"primary"},on:{"click":_vm.viewItem}},'v-icon',attrs,false),on),[_vm._v(" mdi-eye ")])]}}])},[_c('span',[_vm._v("View")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }